import PaymentLinkComponent from './component';
import Header from '../components/Header';
import {Box} from '@mui/material';
import styles from '../styles';

export default function PaymentLinkPage() {
  return (
    <Box sx={styles.wrapper}>
      <Header />
      <PaymentLinkComponent />
    </Box>
  );
}
